import { STORAGE } from "constant";

const TokenStorageService = {
  setToken,
  getAccessToken,
  getRefreshToken,
  clearToken,
};

function setToken(tokenObj: { accessToken: string; refreshToken: string }) {
  localStorage.setItem(STORAGE.LOCAL_ACCESS_TOKEN, tokenObj.accessToken);
  localStorage.setItem(STORAGE.LOCAL_REFRESH_TOKEN, tokenObj.refreshToken);
}
function getAccessToken() {
  return localStorage.getItem(STORAGE.LOCAL_ACCESS_TOKEN);
}
function getRefreshToken() {
  return localStorage.getItem(STORAGE.LOCAL_REFRESH_TOKEN);
}
function clearToken() {
  localStorage.removeItem(STORAGE.LOCAL_ACCESS_TOKEN);
  localStorage.removeItem(STORAGE.LOCAL_REFRESH_TOKEN);
}

export default TokenStorageService;
